/* src/app/private/components/enrollment/add-enrollment/add-enrollment.component.scss */
label {
  font-weight: 600;
  margin-bottom: 10px;
}
.requiredValue::after {
  content: "*";
  color: red;
}
/*# sourceMappingURL=add-enrollment.component.css.map */
